module.exports = require("/home/runner/work/simulator.dev/simulator.dev/.gatsby/gatsby-browser.ts");